import { render, staticRenderFns } from "./ListSucursales.vue?vue&type=template&id=4e6cbe05&"
import script from "./ListSucursales.vue?vue&type=script&lang=js&"
export * from "./ListSucursales.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports